var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTriangleUpOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87381 17.8996H19.1262L12 6.90401L4.87381 17.8996ZM2.17591 18.3548L11.1842 4.45524C11.5776 3.84825 12.4224 3.84825 12.8158 4.45524L21.8241 18.3548C22.2757 19.0516 21.8054 20 21.0083 20H2.99173C2.19458 20 1.7243 19.0516 2.17591 18.3548Z",
    fill: "#040405"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTriangleUpOutlined);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00Ljg3MzgxIDE3Ljg5OTZIMTkuMTI2MkwxMiA2LjkwNDAxTDQuODczODEgMTcuODk5NlpNMi4xNzU5MSAxOC4zNTQ4TDExLjE4NDIgNC40NTUyNEMxMS41Nzc2IDMuODQ4MjUgMTIuNDIyNCAzLjg0ODI1IDEyLjgxNTggNC40NTUyNEwyMS44MjQxIDE4LjM1NDhDMjIuMjc1NyAxOS4wNTE2IDIxLjgwNTQgMjAgMjEuMDA4MyAyMEgyLjk5MTczQzIuMTk0NTggMjAgMS43MjQzIDE5LjA1MTYgMi4xNzU5MSAxOC4zNTQ4WiIgZmlsbD0iIzA0MDQwNSIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };